import { Col, Divider, Radio, Row, Typography } from "antd";
import { getPackageList } from "apps/CustomerPanel/Ad/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserPackage } from "../../Services";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import PackageItem from "./PackageItem";
import { RadioChangeEvent } from "antd/lib";
import { RootState } from "store/Reducers";
import { handleSelectedPackageDoping } from "apps/CustomerPanel/Ad/ClientSideStates";

import 'swiper/css/effect-coverflow';

const Package = () => {
  const pagination = {
    clickable: true,
  };
  const [packageList, setPackageList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedPackages } = useSelector((state: RootState) => state.ad);
  const dispatch = useDispatch()
  function insertArrayAt<T>(
    mainArray: T[],
    index: number,
    includeArray: T[]
  ): T[] {
    if (index < 0 || index > mainArray.length) {
      throw new Error("Index out of bounds");
    }

    return [
      ...mainArray.slice(0, index),
      ...includeArray,
      ...mainArray.slice(index),
    ];
  }

  const getPackages = async (savedDopings: any[]) => {
    setIsLoading(true);
    try {
      const response: any = await getPackageList();
      if (response?.data) {
        if (savedDopings?.length > 0) {
          let currenctIds = savedDopings.map((item) => item.id);
          let filterData = response.data.filter((item: any) => {
            if (currenctIds.includes(item.id)) {
              return false;
            }
            return true;
          });
          console.log("saved", [...filterData, ...savedDopings]);
          const array = insertArrayAt(filterData, 1, savedDopings);

          setPackageList(array);
        } else {
          setPackageList((prevList: any) => [...response.data]);
        }
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.messge);
      console.log("Somethings wrong during getting packages  ", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    managementPackages();
  }, []);

  const managementPackages = async () => {
    setIsLoading(true);
    try {
      const response: any = await getUserPackage();
      if (response?.data) {
        let data = response.data.map((item: any) => {
          if (item?.package) {
            return { ...item?.package, inUser: true };
          }
          return item;
        });

        getPackages(data);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.messge);
      console.log("Somethings wrong during getting packages  ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [value, setValue] = useState(1);

  const onChange = (e: RadioChangeEvent) => {
    let id = e.target.value;
 
    const data = { ...selectedPackages };
    let findItem = packageList.find((item: any) => item.id === id);
    if (findItem) {
      data["package"] = findItem;
      dispatch(handleSelectedPackageDoping({ data }));
    } else {
      openNotificationWithIcon("default", "Paket Bulunamadı");
    }
    setValue(e.target.value);
  };

  return (
    <Col xs={24}>
    <Row gutter={[0, 20]} className="!w-full ">
      <Radio.Group
        onChange={onChange}
        value={value}
        className="!w-full"
        id="plan-group-item"
      >
        <Col xs={24}>
          <Row gutter={[0, 20]}>
            <Col xs={24}>
              <div className="flex justify-center items-center">
                <div className=" w-full">
                  {isLoading ? (
                    <GeneralLoadingSpinner />
                  ) : (
                    <Row className="!w-full" 
                    gutter={[
                      { xs: 0, md: 20,}, 
                      { xs:20 , md: 20}   
                    ]}
                 >
                      {packageList.map((item: any) => (
                        <Fragment  key={item.id}>
                          <Col xs={24} md={12} lg={8} >
                          <PackageItem item={item} />
                          </Col>
                        </Fragment>
                      ))}
                    </Row>
                   
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Radio.Group>
    </Row>
  </Col>
  );
};

export default Package;
